/**
 * The Requests view's CSV export: the page on screen, not the whole
 * window. A server-side export endpoint if anyone asks for more than one
 * page. The columns follow the table, client metadata included
 * (TRA-1397); the tenant cell is the name when the client sent one, else
 * the id, as on screen.
 */

import type { RequestLogItem } from '@/api/generated/model'
import { tenantLabel } from '@/components/listing/clientMetadata'

import { csvCell } from './contracts'

export const REQUEST_CSV_COLUMNS = [
  'timestamp',
  'status_code',
  'model',
  'upstream',
  'fallback_from',
  'served_model',
  'tenant',
  'environment',
  'traffic_type',
  'session_id',
  'initiated_by',
  'prompt_tokens',
  'cached_prompt_tokens',
  'completion_tokens',
  'total_tokens',
  'latency_ms',
  'error_message',
  'trace_key',
] as const

export function requestLogCsv(items: readonly RequestLogItem[]): string {
  const rows = items.map((item) =>
    [
      item.timestamp,
      item.status_code,
      item.request_model,
      item.upstream_id,
      item.fallback_from,
      item.served_model,
      tenantLabel(item),
      item.environment,
      item.traffic_type,
      item.session_id,
      item.initiated_by,
      item.prompt_tokens,
      item.cached_prompt_tokens,
      item.completion_tokens,
      item.total_tokens,
      item.latency_ms,
      item.error_message,
      item.trace_key,
    ]
      .map(csvCell)
      .join(','),
  )
  return [REQUEST_CSV_COLUMNS.join(','), ...rows].join('\n')
}
